import React from 'react';
import { Button, Container } from 'reactstrap';
import { AccountsDiagnosticsSection } from './AccountsDiagnosticsSection';
import { ProductStateSection } from './ProductStateSection';
import { PendingPreviewSection } from '../SynchronizationSection/PendingPreviewSection';
import { WorkerActionsSection } from '../SynchronizationSection/WorkerActionsSection';

type DiagnosticsSectionProperties =
{
    settings: any | null
    getGoogleMerchantAccounts: () => Promise<any>
    prepareGoogleMerchantProduct: (values: any) => Promise<any>
    markProductsDirty: (values: any) => Promise<any>
    searchExportStates: (values: any) => Promise<any>
    preparePending: (values: any) => Promise<any>
    sendPrepared: (values: any) => Promise<any>
}

export default function DiagnosticsSection
(
    {
        settings,
        getGoogleMerchantAccounts,
        prepareGoogleMerchantProduct,
        markProductsDirty,
        searchExportStates,
        preparePending,
        sendPrepared
    }
    : DiagnosticsSectionProperties
)
{
    // const loadOperationalSettings = async () =>
    // {
    //     setLastError(null);
    //     setIsLoadingOperationalSettings(true);

    //     try
    //     {
    //         const result = await getOperationalSettings();
    //         const payload = unwrapPayload(result);

    //         if (payload)
    //         {
    //             setOperationalSettings(payload);
    //         }
    //         else
    //         {
    //             setLastError('Nie udało się pobrać ustawień runtime. Sprawdź log backendu.');
    //         }
    //     }
    //     catch (error: any)
    //     {
    //         setLastError(error?.message ?? 'Pobieranie ustawień runtime zakończyło się błędem.');
    //     }
    //     finally
    //     {
    //         setIsLoadingOperationalSettings(false);
    //     }
    // };

    return (
        <Container fluid>
            <ProductStateSection
                settings={settings}
                prepareGoogleMerchantProduct={prepareGoogleMerchantProduct}
                markProductsDirty={markProductsDirty}
                searchExportStates={searchExportStates}
            />

            <AccountsDiagnosticsSection
                getGoogleMerchantAccounts={getGoogleMerchantAccounts}
            />

            <PendingPreviewSection searchExportStates={searchExportStates} />

            <WorkerActionsSection
                preparePending={preparePending}
                sendPrepared={sendPrepared}
            />

                    {/* <Button
                        type="button"
                        color="secondary"
                        className="mr-2 mb-2"
                        disabled={isLoadingOperationalSettings}
                        onClick={loadOperationalSettings}
                    >
                        Wylicz ustawienia runtime
                    </Button> */}

            {/* {operationalSettings && (
                <div className="mt-4">
                    <h5>Ustawienia runtime</h5>

                    {operationalSettings.warnings && operationalSettings.warnings.length > 0 && (
                        <Alert color="warning">
                            <strong>Ostrzeżenia:</strong>
                            <ul className="mb-0">
                                {operationalSettings.warnings.map((warning: string, index: number) => (
                                    <li key={index}>{warning}</li>
                                ))}
                            </ul>
                        </Alert>
                    )}

                    <div className="mb-3">
                        <span className="mr-4">
                            <strong>Konto:</strong> {operationalSettings.merchantAccountId}
                        </span>
                        <span className="mr-4">
                            <strong>Automatyczna synchronizacja:</strong> {operationalSettings.automaticSynchronizationEnabled ? 'tak' : 'nie'}
                        </span>
                    </div>

                    <ProfilesList title="Aktywne profile runtime" profiles={operationalSettings.activeProfiles || []} />
                    <ProfilesList title="Pominięte / nieaktywne profile" profiles={operationalSettings.inactiveProfiles || []} />

                    <details className="mt-4">
                        <summary>Raw JSON</summary>
                        <pre className="mt-3">{JSON.stringify(operationalSettings, null, 2)}</pre>
                    </details>
                </div>
            )} */}
        </Container>
    );
}

